import * as React from 'react';
import {
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Card,
    CardMedia,
    CardContent,
    CircularProgress,
    Alert,
    Button,
    Stack,
    useTheme,
    useMediaQuery,
    Fade
} from '@mui/material';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import RoomIcon from '@mui/icons-material/Room';
import CloseIcon from '@mui/icons-material/Close';
import LogoRFID from "../imagenes/logorfid.png";
import axios from "axios";

export default function ModalDetalleProducto({ producto }) {

    const [open, setOpen] = React.useState(false);
    const [imagenes, setImagenes] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    React.useEffect(() => {
        if (open && producto) getImagenes();
    }, [open, producto]);

    const getImagenes = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_IMAGENES}?product_id=${producto.idProductos}&order=desc`
            );
            const dataOrdenada = [...res.data].reverse();
            setImagenes(dataOrdenada);
        } catch (err) {
            console.error(err);
            setError('Error al cargar historial');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <IconButton color="primary" onClick={handleOpen}>
                <ManageSearchIcon />
            </IconButton>

            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                fullScreen={isMobile}
                TransitionComponent={Fade}
                PaperProps={{ sx: { borderRadius: isMobile ? 0 : 4, overflow: "hidden" } }}
            >
                {/* HEADER */}
                <Box sx={{
                    px: { xs: 2, md: 4 },
                    py: { xs: 2, md: 3 },
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: 'linear-gradient(90deg, #1976d2, #42a5f5)',
                    color: 'white'
                }}>
                    <Box>
                        <Typography variant="h6" fontWeight={600}>Historial del producto</Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Revisa todas las imágenes y movimientos del producto
                        </Typography>
                    </Box>
                    <IconButton onClick={handleClose} sx={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <DialogContent sx={{ maxHeight: '80vh', overflowY: 'auto', p: { xs: 2, md: 3 } }}>
                    <Stack spacing={3}>
                        {error && <Alert severity="error">{error}</Alert>}

                        {loading ? (
                            <Box display="flex" justifyContent="center" p={4}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            imagenes.length === 0 ? (
                                <Typography textAlign="center" color="text.secondary">
                                    No hay historial disponible
                                </Typography>
                            ) : (
                                imagenes.map((item) => (
                                    <Card key={item.id} sx={{ borderRadius: 3, boxShadow: 2 }}>
<CardMedia
    component="img"
    image={item.foto}
    alt="historial"
    sx={{
        width: '100%',
        maxHeight: 300, // altura máxima de la imagen
        objectFit: 'contain', // mantiene proporción sin recortar
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
        backgroundColor: '#f0f0f0' // opcional, si la imagen no llena el espacio
    }}
/>
                                        <CardContent>
                                            <Typography variant="subtitle1" fontWeight="bold">{item.fechafoto}</Typography>
                                            <Typography variant="body2">Estado: {item.estado}</Typography>
                                            <Typography variant="body2">Ubicación: {item.lugar}</Typography>
                                            <Typography variant="body2">Código: {item.epc}</Typography>
                                            <Typography variant="body2">Descripción: {producto.descripcion}</Typography>

                                            <Button
                                                startIcon={<RoomIcon />}
                                                href={`https://www.google.com/maps?q=${item.latitud},${item.longitud}`}
                                                target="_blank"
                                                sx={{ mt: 1 }}
                                            >
                                                Ver en mapa
                                            </Button>
                                        </CardContent>
                                    </Card>
                                ))
                            )
                        )}
                    </Stack>

                    {/* PANEL DERECHO CON LOGO (opcional) */}
                    <Box
                        sx={{
                            mt: 4,
                            p: 2,
                            borderRadius: 3,
                            background: '#f8fafc',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center'
                        }}
                    >
                        <img src={LogoRFID} alt="logo" style={{ width: 100, opacity: 0.9 }} />
                        <Typography mt={2} fontWeight={500}>
                            Plataforma de gestión RFID
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mt={1}>
                            Consulta los movimientos y ubicaciones de cada producto
                        </Typography>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
}